import type { ApolloCache } from "@apollo/client/cache"

import { evict } from "shared/api/evict"

import { TeamTypename } from "../types/Team"

export function evictTeam(id: string, cache: ApolloCache<object>) {
  evict({ cache, id, typename: TeamTypename })
}
